import React from 'react';

function LoadingSpinner({ message = '載入中...', size = 'md', showMessage = true }) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-12 w-12',
    lg: 'h-16 w-16'
  };

  const containerClasses = size === 'sm' 
    ? 'flex items-center justify-center' 
    : 'flex flex-col items-center justify-center h-64 px-4';

  return (
    <div className={containerClasses}>
      <div className={`animate-spin rounded-full border-b-2 border-primary ${sizeClasses[size]} ${showMessage && size !== 'sm' ? 'mb-4' : ''}`}></div>
      {showMessage && size !== 'sm' && (
        <p className="text-text-primary text-lg">{message}</p>
      )}
    </div>
  );
}

export default LoadingSpinner;